import { createContext } from "solid-js";
const Tablelvl2Context = createContext();
export default Tablelvl2Context;
